<div class="loading_test1"  id="loading_test1"  style="display:none">
  <div class="loading_test" id="loading_test">
    <div class="loader_test_2" id="loader-2">
      <img style="width: 30px;" src="assets/c.svg" alt="Logo Parte 1" />
      <img style="width: 60px;" src="assets/o.svg" alt="Logo Parte 2" />
      <img style="width: 30px;" src="assets/c.svg" alt="Logo Parte 3" />
      <img style="width: 60px;" src="assets/o.svg" alt="Logo Parte 4" />
      <img style="width: 30px;" src="assets/a.svg" alt="Logo Parte 5" />
    </div>
  </div>

</div>

<!-- <div *ngIf="bandera">
  <div class="home-container">
    <app-sidebar></app-sidebar>
    <div class="main-content">

      <div class="content">

      </div>
    </div>
  </div>
</div> -->

<!-- <div *ngIf="!bandera"> -->
<router-outlet></router-outlet>
<!-- </div> -->
